const getSortable = () => import('sortablejs')

/* @ngInject */
function SubtasksSectionController ($scope, $attrs, $timeout, TasksService, ToastService, SegmentService) {
  $scope.subtasks = []
  $scope.archivedSubtasks = []
  $scope.progressBarStacks = []
  $scope.isCreatingSubtask = false
  $scope.newSubtaskTitle = ''
  $scope.donePercentage = 0
  $scope.showArchivedSubtasks = false
  $scope.flags = {
    isCollapsed: false
  }
  let sortableSubtasks = []

  const api = {
    _getSubtasks,
    _getArchivedSubtasks,
    _handleStackedProgressBar,
    _initializeSortable,
    _onUpdateSubtaskSort
  }
  this.getApi = () => api

  const deregisterCollapsedWatch = $scope.$watch('flags.isCollapsed', (newValue) => {
    $scope.$emit('subtasks-section-collapsed-changed', newValue)
  })

  const deregisterTaskWatch = $scope.$watchGroup(['task.id', 'task.status', 'task.columnId', 'task.originType'], () => {
    if ($scope.task) {
      api._getSubtasks()
    }
  })

  $scope.$on('$destroy', () => {
    deregisterCollapsedWatch()
    deregisterTaskWatch()
  })

  function _getSubtasks () {
    $scope.subtasks = []
    TasksService.getSubtasks($scope.task.id).then((subtasks) => {
      $timeout(() => {
        $scope.subtasks = subtasks
        api._handleStackedProgressBar()
        api._initializeSortable()
      }, 0, true)
    }).catch(ToastService.defaultErrorToast)
  }

  function _getArchivedSubtasks () {
    TasksService.getSubtasks($scope.task.id, { isArchived: true }).then((subtasks) => {
      $scope.archivedSubtasks = subtasks
    })
  }

  function _initializeSortable () {
    getSortable().then(({ Sortable }) => {
      let subtasksToSort = document.getElementsByClassName('subtasks-section__content')
      subtasksToSort = Array.from(subtasksToSort)

      sortableSubtasks = []

      subtasksToSort.forEach(subtask => {
        sortableSubtasks.push(Sortable.create(subtask, {
          sort: true,
          animation: 150,
          ghostClass: 'subtask-ghost',
          handle: '.subtask-handler',
          onUpdate: api._onUpdateSubtaskSort
        }))
      })
    })
  }

  function _onUpdateSubtaskSort (event) {
    const subtaskId = parseInt(event.item.id)
    const position = event.newIndex + 1

    TasksService.reorderSubtask($scope.task.id, subtaskId, position).catch(ToastService.defaultErrorToast)
  }

  function _handleStackedProgressBar () {
    const doneCount = $scope.subtasks.filter(subtask => subtask.status === 'DONE').length
    const inProgressCount = $scope.subtasks.filter(subtask => subtask.status === 'PROGRESS').length
    const donePercentage = (doneCount * 100) / $scope.subtasks.length
    $scope.donePercentage = Math.ceil(donePercentage)

    $scope.progressBarStacks = [
      {
        name: 'Done',
        count: doneCount,
        color: '#D0EEDC'
      },
      {
        name: 'In Progress',
        count: inProgressCount,
        color: '#D1EBFF'
      }
    ]
  }

  $scope.onSubtaskChange = (subtask) => {
    api._getSubtasks()
  }

  $scope.handleAddSubtaskClick = () => {
    $scope.flags.isCollapsed = false
    $scope.isCreatingSubtask = true

    $timeout(() => {
      const input = $attrs.$$element.find('.subtasks-section__creation--input')[0]
      input.focus()

      if ($scope.subtasks.length > 3) {
        input.scrollIntoView()
      }
    }, 100, true)
  }

  $scope.cancelSubtaskCreation = () => {
    $scope.newSubtaskTitle = ''
    $scope.isCreatingSubtask = false
  }

  $scope.confirmSubtaskCreation = () => {
    TasksService.createSubtask({
      title: $scope.newSubtaskTitle,
      boardId: $scope.task.column.boardId,
      taskId: $scope.task.id,
      status: 'INBOX',
      priority: 'MEDIUM',
      campaignId: $scope.task.campaignId
    }).then((subtask) => {
      $scope.newSubtaskTitle = ''
      $scope.isCreatingSubtask = false

      SegmentService.track('created-task', { type: 'SUBTASK', task_id: subtask.id, campaign_id: $scope.task.campaignId })
      SegmentService.track('created-subtask', { type: 'SUBTASK', task_id: subtask.id, campaign_id: $scope.task.campaignId })
      api._getSubtasks()
      api._handleStackedProgressBar()
    }).catch(ToastService.defaultErrorToast)
  }

  $scope.toggleArchivedSubtasks = (state) => {
    $timeout(() => {
      $scope.showArchivedSubtasks = state

      if ($scope.showArchivedSubtasks) {
        api._getArchivedSubtasks()
      }
    }, 0, true)
  }

  $scope.handleInputChange = (inputEv) => {
    if (inputEv.keyCode === 13 && $scope.newSubtaskTitle.length > 0) {
      $scope.confirmSubtaskCreation()
    }
  }
}

export { SubtasksSectionController }
